import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import RenderContent from "./RenderContent";
import mizanListAPI from "../../../Network/MizanList";

const cookies = new Cookies();

export default function FormContainer({ object, openForm, setOpenForm, loadData }) {
    const [t] = useTranslation("common");
    const maintheme = useSelector((state) => state.themeData.maintheme);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        display_name: "",
        code: "",
        municipality_id: null,
        municipality_selected: null,
        geofence_id: null,
        geofence_selected: null,
        enabled: 1
    });

    useEffect(() => {
        if (object) {
            setFormData({
                display_name: object.display_name || "",
                code: object.code || "",
                municipality_id: object.municipality_id,
                municipality_selected: object.municipality_id ? { id: object.municipality_id, name: object.municipality_name } : null,
                geofence_id: object.geofence_id,
                geofence_selected: object.geofence_id ? { id: object.geofence_id, name: object.geofence_name } : null,
                enabled: object.enabled !== undefined ? object.enabled : 1
            });
        } else {
            setFormData({
                display_name: "",
                code: "",
                municipality_id: null,
                municipality_selected: null,
                geofence_id: null,
                geofence_selected: null,
                enabled: 1
            });
        }
    }, [object]);

    const handleClose = () => {
        setOpenForm(false);
    };

    const handleSave = async () => {
        if (!formData.display_name) {
            toast.warn(t('GLOBAL.required_fields') || 'الرجاء ملء الحقول المطلوبة');
            return;
        }

        setLoading(true);

        const params = {
            username: cookies.get("user_name"),
            user_id: cookies.get("user_id"),
            account_name: cookies.get("account_name"),
            account_id: cookies.get("account_id"),
            sid: cookies.get("sid"),
            baseurl: cookies.get("baseUrl"),
            id: cookies.get("id"),
        };

        const data = {
            display_name: formData.display_name,
            code: formData.code,
            municipality_id: formData.municipality_id || '',
            geofence_id: formData.geofence_id || '',
            enabled: formData.enabled
        };

        let result;
        if (object) {
            result = await mizanListAPI.editMizan({
                id: object.id,
                params,
                data
            });
        } else {
            result = await mizanListAPI.addMizan({
                params,
                data
            });
        }

        setLoading(false);

        if (result.status && result?.data?.status) {
            toast.success(object ? (t('NETWORK_MESSAGES.updateSuccess') || 'تم التحديث بنجاح') : (t('NETWORK_MESSAGES.insertSuccess') || 'تمت الإضافة بنجاح'));
            setOpenForm(false);
            loadData();
        } else {
            toast.error(result?.data?.data?.message?.text || t('NETWORK_MESSAGES.unknownError'));
        }
    };

    return (
        <Dialog
            open={openForm}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: "12px" }
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: maintheme?.primary,
                    color: "#fff",
                    fontFamily: "Cairo-Bold",
                }}
            >
                {object ? (t('MIZAN_LIST.edit') || 'تعديل الميزان') : (t('MIZAN_LIST.add') || 'إضافة ميزان')}
                <IconButton onClick={handleClose} sx={{ color: "#fff" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: "24px" }}>
                <RenderContent
                    formData={formData}
                    setFormData={setFormData}
                />
            </DialogContent>
            <DialogActions sx={{ padding: "16px" }}>
                <Button
                    onClick={handleClose}
                    sx={{ fontFamily: "Cairo-Medium" }}
                >
                    {t("GLOBAL.action_cancel") || "إلغاء"}
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    disabled={loading}
                    sx={{
                        fontFamily: "Cairo-Medium",
                        backgroundColor: maintheme?.primary,
                        "&:hover": { backgroundColor: maintheme?.secondary },
                    }}
                >
                    {loading ? <CircularProgress size={20} color="inherit" /> : (t("GLOBAL.action_save") || "حفظ")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
